import "./couple.css";

const NoPhotoCouple = ({ values }) => {

  const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t1-couple-person">

        <div className="t1-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t1-couple-name">
          {fullname}
        </h1>

        <div className="t1-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });

      const desktopFrameBaseUrl =
  "https://res.cloudinary.com/depixc8dq/image/upload/v1792631861/aamantran%20assets/theme1-couple-frame-desktop_d08hwl.png";

const extendedFrameBaseUrl =
  "https://res.cloudinary.com/depixc8dq/image/upload/v1792631861/aamantran%20assets/floral1-mobile-frame-extended_sxehvw.png";

const getOptimizedFrameUrl = (url, width) =>
  url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);

const desktopFrameSrc = getOptimizedFrameUrl(
  desktopFrameBaseUrl,
  1080
);

const extendedFrameSrc = getOptimizedFrameUrl(
  extendedFrameBaseUrl,
  640
);

const extendedFrameSrcSet = [320, 640, 1080]
  .map(
    (width) =>
      `${getOptimizedFrameUrl(extendedFrameBaseUrl, width)} ${width}w`
  )
  .join(", ");

  return (
    <div className="t1-couple-section t1-nophoto-couple">

      {/* <picture>

        <source
          media="(min-width:768px)"
          srcSet="/theme1-couple-frame-desktop.png"
        />

        <img
          src="/floral1-mobile-frame-extended.png"
          alt="Couple Frame"
          className="t1-couple-frame"
        />

      </picture> */}

         <picture>
    <source
      media="(min-width: 768px)"
      srcSet={desktopFrameSrc}
    />

    <img
      src={extendedFrameSrc}
      srcSet={extendedFrameSrcSet}
      sizes="(max-width: 480px) 320px, (max-width: 767px) 640px"
      alt=""
      className="t1-couple-frame"
    />
  </picture>

      <div className="t1-couple-inner">

        <h2 className="t1-couple-heading">
          {values.sectionHeading}
        </h2>

        <div className="t1-couple-content">

          {values.displayOrder === "groomFirst" ? (
            <>
              {groomCard()}

              <div className="t1-couple-divider">
                &
              </div>

              {brideCard()}
            </>
          ) : (
            <>
              {brideCard()}

              <div className="t1-couple-divider">
                &
              </div>

              {groomCard()}
            </>
          )}

        </div>

      </div>

    </div>
  );
};

export default NoPhotoCouple;